import React from 'react';
import store, {history} from "../store";
import Right from "./Right";
import Panel from "./Panel";

import langs from "./langs/phpIndex";
import {api, parsePHPtime} from "./baseFunctions";

class LogPage extends React.Component {
  constructor()
  {
    super();
    this.state = {
    	data: [],
    };
  }
  componentWillMount(){
  	api("POST", {"type": "getLogs"}, (d) => {
  		if(!d.error)
  		{
  			this.setState({
  				data: d.data,
  			});
        requestAnimationFrame(() => {
          this.overViewTable = window.$("#sheets").DataTable(langs[this.props.lang].DATA_OPTIONS);
        });
  		}
    }, this.props.auth, 1);
  }
	render(){
 
    
		return (
			<Right token={this.props.auth} lang={this.props.lang}>
				<Panel title="Logs">
            <table className="table table-striped jambo_table bulk_action" id="sheets">
              <thead>
                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">UserID </th>
                      <th className="column-title">TargetID</th>
                      <th className="column-title">Action</th>
                      <th className="column-title">Tidspunkt</th>
                      <th className="column-title">IP</th>
                  </tr>
              </thead>
              <tbody>
             	{
             		this.state.data.map((d, key) => <tr className="headings" key={key}>
                      <td className="column-title">{d.id}</td>
                      <td className="column-title">{d.user}</td>
                      <td className="column-title">{d.target}</td>
                      <td className="column-title">{d.action}</td>
                      <td className="column-title">{parsePHPtime(d.time)}</td>
                      <td className="column-title">{d.ip}</td>
                  </tr>)
             	}
              </tbody>
            </table>
        
      </Panel>
      </Right>);
	}
}

export default LogPage;


// WEBPACK FOOTER //
// ./src/components/LogPage.js